export const HEALTH_ENDPOINT = `${process.env.REACT_APP_API_URL}/api/vault77/health`;
